import { THEMES_POSTFIX_URL, TOPICS_URL, WEBSITE_URL } from '../constants/APIConstants';
import ky from './kyextended';

const getTopics = (webId) => ky.get(`${WEBSITE_URL}${webId}${TOPICS_URL}`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();

const getCommonTopics = (webId) => ky.get(`v1${TOPICS_URL}common/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();

const createTopic = (topicDetails, webId) => ky.post(`${WEBSITE_URL}${webId}${TOPICS_URL}`, {
    json: topicDetails,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();

const createCommonTopic = (topicDetails) =>  ky.post(`v1${TOPICS_URL}multi/`, {
    json: topicDetails,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();

const updateTopic = ({topicDetails, webId, id}) => ky.patch(`${WEBSITE_URL}${webId}${TOPICS_URL}${id}/`,{
    json: topicDetails,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();

const deleteTopic = (webId, id) => ky.delete(`${WEBSITE_URL}${webId}${TOPICS_URL}${id}/`,{
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();


const getThemes = (webId) => ky.get(`${WEBSITE_URL}${webId}${THEMES_POSTFIX_URL}`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const setTheme = (webId, formData) => ky.patch(`${WEBSITE_URL}${webId}${THEMES_POSTFIX_URL}`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export {getTopics, createTopic, updateTopic, deleteTopic, getThemes, setTheme, createCommonTopic, getCommonTopics };